module.exports = __webpack_public_path__ + "static/media/04.74aac5ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/australia/04.jpg
// module id = 405
// module chunks = 0